import GenericFileIcon from './GenericFileIcon'

export default GenericFileIcon
